import React, { useState } from 'react';
import {
  FaBars,
  FaTimes,
  FaInstagram,
  //FaWhatsapp,
  FaFacebook,
  FaTiktok,
} from 'react-icons/fa';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div className='fixed z-10 w-full h-[60px] flex justify-between items-center px-4 bg-[#1f1f1f] text-white	'>
      <div className='flex items-center'>
        <Link to='home' smooth={true} duration={500} className='cursor-pointer'>
          <p className='text-xl font-semibold'>Serviabogados CM</p>
        </Link>
      </div>

      {/* menu */}
      <ul className='hidden md:flex'>
        <li>
          <Link to='home' smooth={true}  duration={500} activeClass="active" className=' focus:outline-none focus:ring focus:ring-violet-300'>
            Inicio
          </Link>
        </li>
        <li>
          <Link to='quienes-somos' smooth={true}  duration={500}>
            Quiénes Somos
          </Link>
        </li>
        <li>
          <Link to='servicios' smooth={true} duration={500}>
            Servicios
          </Link>
        </li>

        <li>
          <Link to='footer' offset={-50} smooth={true} duration={500}>
            Contactenos
          </Link>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-10'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen text-gray-300 bg-[#343a40] flex flex-col justify-center items-center'
        }
      >
        <li className='py-6 text-4xl'>
          <Link onClick={handleClick} to='home' smooth={true} duration={500}>
            Inicio
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='quienes-somos' smooth={true} duration={500}>
            Quiénes Somos
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='servicios' smooth={true} duration={500}>
            Servicios
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='footer' smooth={true} duration={500}>
            Contacto
          </Link>
        </li>
      </ul>

      {/* Social icons */}
      <div className='hidden lg:flex fixed flex-col top-[50%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between rounded-tr-3xl items-center ml-[-100px] hover:rounded-r-3xl hover:ml-[-10px] duration-300 bg-[#cbcfd3]'>
            <a
              className='flex justify-between items-center w-full text-stone-800'
              href='https://www.instagram.com/serviabogadoscm/' target='_blank' rel="noreferrer"
            >
              Instagram <FaInstagram size={30} />
            </a>
          </li>

          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:rounded-r-3xl hover:ml-[-10px] duration-300 bg-black'>
            <a
              className='flex justify-between items-center w-full text-white'
              href='https://www.tiktok.com/@serviabogadoscm/' target='_blank' rel="noreferrer"
            >
              TikTok <FaTiktok size={30} />
            </a>
          </li>

          <li className='w-[160px] h-[60px] flex justify-between rounded-br-3xl items-center ml-[-100px] hover:rounded-r-3xl hover:ml-[-10px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-white'
              href='https://www.facebook.com/' target='_blank' rel="noreferrer"
            >
              Facebook <FaFacebook size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
